import { getViewport } from 'js/tools';

const breakpoints = {
    mobile: { from: 0, to: 639 },
    tablet: { from: 640, to: 959 },
    desktop: { from: 960, to: 1699 },
    bigScreen: { from: 1700 },

    onBreakpoint(name) {
        const viewportWidth = this.getViewportWidth();

        return viewportWidth >= breakpoints[name].from && viewportWidth <= breakpoints[name].to;
    },

    onBreakpointOrGreater(name) {
        return this.getViewportWidth() >= breakpoints[name].from;
    },

    getViewportWidth: () => getViewport().width
};

export default breakpoints;
